import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MasterService } from '../../../services/master.service';
import { StoreService } from '../../../services/store.service';
import * as words from '../../../services/language'

import { Subscription } from 'rxjs';
import { Sale } from 'src/app/models/sale.model';
import { daysAgo } from 'src/app/utils/date';
import moment from 'moment';

@Component({
    selector: 'sales-in-progress',
    templateUrl: './sales-in-progress.component.html',
    styleUrls: ['./sales-in-progress.component.scss'],
    standalone: false
})
export class SalesInProgressComponent implements OnInit, OnChanges, OnDestroy {

    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // Word replacements for each language.
    @Input() words: Object = words.language

    // Currently selected lot.
    protected lotId: number = 0

    // A list of pending sales.
    protected sales: Array<Sale> = []

    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    private channelSubscription: Subscription | null = null

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        this.lotId = parseInt(localStorage.getItem('lot') || '0')
        this.fetch()

        this.channelSubscription = this.ms.channelComponents$.subscribe((event) => {
            if (!event || !event.message) {
                return
            }

            switch (event.message) {
                case 'changeLot':
                    const id = parseInt(event.value.lot)

                    if (this.lotId == id) {
                        return
                    }

                    this.lotId = id
                    this.fetch()
                    break
            }
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
    }

    ngOnDestroy(): void {
        if (this.channelSubscription) {
            this.channelSubscription.unsubscribe()
            this.channelSubscription = null
        }
    }

    /**
     * 
     */
    private fetch() {
        if (this.loading) {
            return
        }

        if (!this.lotId || this.lotId <= 0) {
            return
        }

        this.sales = null
        this.sales = []

        const stageIsQuote: number = 1
        const statusIsPending: number = 1

        this.loading = true
        this.master.get(`sales?pi=1&ipp=9&stage=${stageIsQuote}&status=${statusIsPending}&lotId=${this.lotId}&sort=sold|desc`, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.sales = res.data.sales
        })
    }

    /**
     * Mark the given sale as sold.
     * @param e 
     */
    protected markAsSold = (e: Event, index: number) => {
        if (!this.sales || (this.sales.length <= 0)) {
            return
        }

        if (index < 0 || (index > (this.sales.length - 1))) {
            return
        }

        const sale = this.sales[index]
        const payload = {

        }

        this.master.patch(`sales/${sale.id}`, payload, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.sales.splice(index, 1)
        })
    }

    /**
     * 
     * @param sold 
     * @returns 
     */
    protected when = (sold) => {
        const days = Math.abs(daysAgo(moment(sold).format('YYYY-MM-DD')))

        if (days === 0) {
            return 'today'
        }

        if (days === 1) {
            'yesterday'
        }

        return `${days}d`
    }
}
